import { SetupIntroductionStep } from "@/components/setup/setup-introduction-step";
import { useTeams } from "@/contexts/teams-provider";

export const SetupResubscriptionBillingIntroductionPage = () => {
  const { teamSelected } = useTeams();

  return (
    <SetupIntroductionStep
      translationPrefix="setup.resubscriptionBilling.introduction"
      translationParams={{ teamName: teamSelected?.name || "" }}
    />
  );
};
